<template>
    <form class="add-admin-user" v-bind:action="apiUrl + '/users' + (id ? ('/' + id) : '')" v-on:submit.prevent="handleSubmit">
        <div class="form__group" v-bind:class="{ 'has-error' : errors.name }">
            <label class="form__label" for="name">{{ __('Name') }}</label>
            <input class="form__control is-large" id="name" type="text" autocomplete="off"
                   v-bind:placeholder="__('Enter name')"
                   v-model="name"
            />
            <span class="form__focus"></span>
        </div>
        <small class="form__error" v-if="errors.name">{{ errors.name[0] }}</small>

        <div class="form__group" v-bind:class="{ 'has-error' : errors.email }">
            <label class="form__label" for="email">{{ __('Email') }}</label>
            <input class="form__control is-large" id="email" type="email" autocomplete="off"
                   v-bind:placeholder="__('Enter email')"
                   v-model="email"
            />
            <span class="form__focus"></span>
        </div>
        <small class="form__error" v-if="errors.email">{{ errors.email[0] }}</small>

        <div class="form__group" v-bind:class="{ 'has-error' : errors.role }">
            <label class="form__label" for="role">{{ __('User type') }}</label>
            <select class="form__control" id="role"
                    v-model="role"
            >
                <option value="1">{{ __('Super Admin') }}</option>
                <option value="2">{{ __('Admin') }}</option>
                <option value="3">{{ __('User') }}</option>
            </select>
            <span class="form__focus"></span>
        </div>
        <small class="form__error" v-if="errors.role">{{ errors.role[0] }}</small>

        <div class="form__group" v-bind:class="{ 'has-error' : errors.password }">
            <label class="form__label" for="password">{{ __('Password') }}</label>
            <input class="form__control is-large" id="password" type="password" autocomplete="off"
                   v-bind:placeholder="__('Enter password')"
                   v-model="password"
            />
            <span class="form__focus"></span>
        </div>
        <small class="form__error" v-if="errors.password">{{ errors.password[0] }}</small>

        <div class="form__group">
            <label class="form__label" for="password-confirm">{{ __('Confirm password') }}</label>
            <input class="form__control is-large" id="password-confirm" type="password" autocomplete="off"
                   v-bind:placeholder="__('Enter the same password')"
                   v-model="confirmPassword"
            />
            <span class="form__focus"></span>
        </div>

        <button class="btn is-primary edit-tile__save-btn" type="submit">{{ __('Save') }}</button>
    </form>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    import fileControl from '../elements/FileControl.vue';

    export default {
        components: {
            fileControl
        },
        data: function () {
            return {
                confirmPassword: '',
                email: '',
                errors: {},
                initEmail: '',
                name: '',
                password: '',
                role: ''
            }
        },
        methods: {
            getUser: function () {
                eventBus.$emit('show-loader');

                this.$http.get(this.apiUrl + '/users/' + this.id).then(function (response) {
                    const user = response.body;

                    this.email = user.email;
                    this.initEmail = user.email;
                    this.name = user.name;
                    this.role = user.role_id

                    eventBus.$emit('hide-loader');
                }, function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            handleSubmit: function (e) {
                const form = e.target;
                const action = form.getAttribute('action');
                const method = this.id ? 'patch' : 'post';

                eventBus.$emit('show-loader');

                let data = {
                    name: this.name,
                    role_id: this.role
                };

                if (this.email != this.initEmail) {
                    data.email = this.email;
                }

                if (this.password != '') {
                    data.confirmPassword = this.confirmPassword;
                    data.password = this.password;
                }

                this.$http[method](action, data).then(function (response) {
                    eventBus.$emit('hide-loader');

                    eventBus.$emit('show-alert', 'success', this.__('User has been successfully saved.'));

                    this.$router.push({
                        name: 'users'
                    });
                }, function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit('hide-loader');

                    eventBus.$emit(
                        'show-alert',
                        'error',
                        this.__('There were some errors validation the form. Please review and correct them.')
                    );
                });
            },
            init: function () {
                if (this.id) {
                    this.getUser();
                }
            }
        },
        mounted: function () {
            this.init();
        },
        props: {
            id: {
                default: null,
                type: Number
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/EditUser.vue